var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-mobile-header"},[_c('div',[_c('BytecookieLogo'),_c('div',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('X')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }